export default {
  WX: "wx",
  YS: "ys",
  YP: "yp",
  WEB: 'web',
};



// WEBPACK FOOTER //
// ./src/config/env.js